import React, { useState } from 'react';

interface ShareButtonProps {
  url?: string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
}

const ShareButton: React.FC<ShareButtonProps> = ({ 
  url = window.location.href, 
  title = document.title,
  className = '',
  style = {}
}) => {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    try {
      // Web Share API가 지원되는 경우
      if (navigator.share) {
        await navigator.share({
          title: title,
          url: url
        });
      } else {
        // 클립보드 API 사용
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    } catch (error) {
      // 폴백: 텍스트 선택 방식
      const textArea = document.createElement('textarea');
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const defaultStyle: React.CSSProperties = {
    background: copied ? '#28a745' : 'transparent',
    color: copied ? 'white' : '#666',
    border: copied ? 'none' : '1px solid #ddd',
    padding: '0.5rem 1rem',
    borderRadius: '20px',
    fontSize: '0.9rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    boxShadow: 'none',
    ...style
  };

  return (
    <button
      onClick={handleShare}
      className={className}
      style={defaultStyle}
      onMouseEnter={(e) => {
        if (!copied) {
          e.currentTarget.style.background = '#f8f9fa';
          e.currentTarget.style.borderColor = '#adb5bd';
        }
      }}
      onMouseLeave={(e) => {
        if (!copied) {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.borderColor = '#ddd';
        }
      }}
    >
      {copied ? (
        <>
          <span>✓</span>
          <span>복사됨!</span>
        </>
      ) : (
        <>
          <span>🔗</span>
          <span>공유하기</span>
        </>
      )}
    </button>
  );
};

export default ShareButton; 